import { isRouteErrorResponse, useRouteError, Link } from 'react-router-dom';
import { ErrorState } from '@/components/states/ErrorState';

export function ErrorBoundaryRoute() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <ErrorState
        title={`Error ${error.status}`}
        description={error.statusText || 'No pudimos cargar esta página.'}
        action={<Link to="/">Volver al inicio</Link>}
      />
    );
  }

  const message = error instanceof Error ? error.message : 'Error desconocido';
  return (
    <ErrorState
      title="Algo salió mal"
      description={message}
      action={<Link to="/">Volver al inicio</Link>}
    />
  );
}
